import React from "react";
import { Routes, Route } from "react-router-dom";
import ListLocality from "../Components/Locality/listLocality";
import AddLocality from "../Components/Locality/addLocality";
import EditLocality from "../Components/Locality/editLocality";
import ViewLocality from "../Components/Locality/viewlocality";

const localityRoutes = () => {
  return (
    <Routes>
      <Route
        path="/locality"
        element={<ListLocality></ListLocality>}
      ></Route>
      <Route
        path="/locality/add"
        element={<AddLocality></AddLocality>}
      ></Route>
      <Route path="/locality/edit/:id" element={<EditLocality> </EditLocality>}></Route>
      <Route path="/locality/view/:id" element={<ViewLocality> </ViewLocality>}></Route>
    </Routes>
  );
};

export default localityRoutes;
